<template>
  <H5Account v-if="isMobile === 'MOBILE'" />
</template>

<script setup>
import H5Account from './H5Account/index.vue'

const isMobile = ref('')
onBeforeMount(() => {
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})
</script>
